<template>
  <div class="searchBox" :style="{
    'background': data.infoItme.bjColor,
    'padding': `${data.infoItme.sBj} ${data.infoItme.yeBj} ${data.infoItme.xBj}`
  }">
    <el-input :class="[data.alignValue === '居左' ? 'textLeft' : 'textCen']" :style="{
      'border': data.styleValue === '描边' ? '1px solid #DCDFE6' : 'none',
      'border-color': data.miaoColor,
      'border-radius': data.jiaoValue === '直角' ? '0px' : '20px',
      'text-align': data.alignValue === '居左' ? 'left' : 'center',
      'background': data.styleValue === '描边' ? '#ffffff' : data.tianColor,
    }" prefix-icon="el-icon-search" v-model="data.text">
    </el-input>
  </div>
</template>
<script>

export default {
  name: 'seachView',
  props: {
    data: Object
  },
  data () {
    return {
      input2: ''
    }
  },
  methods: {},
  mounted () {
    console.log(this.data)
  },
  created () {
  },
  beforeDestroy () {
  }
}
</script>

<style scoped>
.searchBox {
  padding: 15px;
}

/deep/ .el-input__inner {
  background-color: transparent;
  border: none;
}

/deep/ .textLeft .el-input__inner {
  text-align: left;
}

/deep/ .textCen .el-input__inner {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/seach/seachPreview.vue